import React from 'react';

export const BedEstate = () => (
  <g
    transform="matrix(38.571429,0,0,38.571429,-6e-6,135)"
    strokeWidth="0.02592593"
  >
    <path
      d="m 2,11 h 24 v 8 H 25 V 17 H 3 v 2 H 2 Z M 18.5,7 c 1.871,0 2.965,0.414 3.5,0.656 V 9 H 15 V 7.656 C 15.535,7.414 16.629,7 18.5,7 Z m -9,0 c 1.871,0 2.965,0.414 3.5,0.656 V 9 H 6 V 7.656 C 6.535,7.414 7.629,7 9.5,7 Z M 14,2 c 4.336,0 7.465,0.723 9.5,1.438 1.754,0.613 2.285,1.042 2.5,1.187 V 9 H 24 V 6.406 L 23.5,6.125 C 23.5,6.125 21.445,5 18.5,5 16.375,5 14.762,5.578 14,5.906 A 11.496,11.496 0 0 0 9.5,5 c -2.945,0 -5,1.125 -5,1.125 L 4,6.406 V 9 H 2 V 4.625 C 2.215,4.48 2.746,4.051 4.5,3.437 6.535,2.724 9.664,2 14,2 Z M 14,0 C 9.437,0 6.082,0.777 3.844,1.563 1.605,2.348 0.406,3.188 0.406,3.188 L 0,3.5 V 21 h 5 v -2 h 18 v 2 h 5 V 3.5 L 27.594,3.187 c 0,0 -1.2,-0.84 -3.438,-1.624 C 21.918,0.776 18.563,0 14,0 Z"
      fill="#c2ccd8"
      strokeWidth="0.02592593"
    />
  </g>
);
